import { render } from "./Static.vue?vue&type=template&id=ca64823a&scoped=true"
import script from "./Static.vue?vue&type=script&lang=js"
export * from "./Static.vue?vue&type=script&lang=js"

import "./Static.vue?vue&type=style&index=0&id=ca64823a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca64823a"]])

export default __exports__